module.exports = __webpack_public_path__ + "static/media/OpenSans.65066558.woff";